import Config from "@skin_config";
import { getAuthData } from "@common/helpers/auth";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";

export const setSwarmBetshopSessionInfo = () => {
  if (!Config.main.subscribeToCashdesk) return true;

  const authData = getAuthData();

  const requestData = {
    cashdesk: { Id: parseInt(authData?.tid, 10) },
    token: authData?.token,
    site_id: authData?.pid,
  };

  return swarmRequest(requestData, 'betshop_set_session_info');
};
